import axios from 'axios';
import BaseService from './BaseService';

export interface CustomerProps {
    cpf: string;
    first_name: string;
    id: number;
    is_confirmed: boolean;
    last_name: string;
    name: string;
}

export interface RegisterProps {
  mobile_phone: string;
  first_name: string;
  last_name: string;
}

export interface BasicRegisterProps {
  mobile_phone: string;
  first_name: string;
}

export interface LoginProps {
  email: string;
  password: string;
}

export interface PasswordRecoverProps {
  email: string;
}

export interface PasswordResetProps {
  password: string;
  password_confirmation: string;
  token: string;
}

export interface PasswordUpdateProps {
  current_password: string;
  password: string;
  password_confirmation: string;
}

export interface GenerateTokenProps {
  number: string;
}

export interface ValidateTokenProps {
  user_token: string;
  user_hash: string;
  phone_number: string;
}

export interface UpdateProfileProps {
  first_name?: string;
  last_name?: string;
  cpf?: string;
  gender?: string;
  mobile_phone?: string;
  email?: string;
}

export interface GetCardsProps {
  store_id: string;
}

export interface GetCartOpenProps {
  store_id: number;
  order_type: number;
}

export interface SearchByPhoneProps {
  phone_number: string,
  order_type: number
}

export interface KeycloakDecryptProps {
  state: string,
  session_state: string,
  code: string
  hash: string,
  guest_token: string
}

export interface GetCustomerOrdersProps {
  user_id: number;
}

export interface GetCustomerOrdersTodayProps {
  user_id: number;
}

export interface RegisterCardProps {
  name: string;
  number: number;
  expiration_month: number;
  expiration_year: number;
  cvc: number;
  holder_document: number;
  billing_country: string;
  billing_zip_code: number;
  billing_state: string;
  billing_city: string;
  billing_neighborhood: string;
  billing_street: string;
  billing_street_number: number;
  store_id: number;
  main: boolean;
  card?: any;
}

export interface UpdatePasswordProps {
  current_password: string;
  password: string;
  password_confirmation: string;
}

export default class CustomerService {
  baseService: BaseService;
  ApiBaseService: BaseService;

  constructor(orderType: string) {
    this.baseService = new BaseService(orderType);
    this.ApiBaseService = new BaseService('');
  }

  async searchByPhone(payload: SearchByPhoneProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ profile: CustomerProps }>('customers/validate', payload);
      return response.data.profile;
    } catch (error) {
      console.error('Erro customer:', error);
      throw error;
    }
  }

   async checkWhatsapp(): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get('customers/check-whatsapp');
      return response.data;
    } catch (error) {
      console.error('Erro checkWhatsapp:', error);
      throw error;
    }
  }

  async registerStoreCounter(payload: RegisterProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: RegisterProps }>('customers/register', payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async register(payload: RegisterProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: RegisterProps }>('register', payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async basicRegister(payload: BasicRegisterProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: BasicRegisterProps }>('basic-register', payload);
      return response.data;
    } catch (error) {
      console.error('Erro basic register:', error);
      throw error;
    }
  }

  async login(payload: LoginProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: LoginProps }>('/auth', payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  
  async passwordRecover(payload: PasswordRecoverProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: PasswordRecoverProps }>('/auth/password/recover', payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async passwordReset(payload: PasswordResetProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: PasswordResetProps }>('/auth/password/reset', payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async passwordUpdate(payload: PasswordUpdateProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: PasswordUpdateProps }>('/customers/password', payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async generateToken(payload: GenerateTokenProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: GenerateTokenProps }>('customers/generate-token', payload);
      return response.data;
    } catch (error) {
      console.error('Erro generate token:', error);
      throw error;
    }
  }

  async validateToken(payload: ValidateTokenProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: ValidateTokenProps }>('customers/validate-token', payload);
      return response.data;
    } catch (error) {
      console.error('Erro validate token:', error);
      throw error;
    }
  }

  async updateProfile(payload: UpdateProfileProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: UpdateProfileProps }>(`customers/profile`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro validate updateProfile:', error);
      throw error;
    }
  }

  async getCardsStoreCounter(params: GetCardsProps): Promise<any> {
    try {
      const response = await this.baseService.http.get<{ params: GetCardsProps }>(`customers/cards?store_id=${params.store_id}`);
      return response.data;
    } catch (error) {
      console.error('Erro getCards:', error);
      throw error;
    }
  }

  async getCards(user_id: number, params: GetCardsProps): Promise<any> {
    try {
      const response = await this.baseService.http.get<{ params: GetCardsProps }>(`customers/${user_id}/cards?store_id=${params.store_id}`);
      return response.data;
    } catch (error) {
      console.error('Erro getCards:', error);
      throw error;
    }
  }

  async registerCard(user_id: number, payload: RegisterCardProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<RegisterCardProps>(`customers/${user_id}/cards/create`, payload);
      return response.data.card;
    } catch (error) {
      console.error('Erro registerCard:', error);
      throw error;
    }
  }

  async registerCardStoreCounter(payload: RegisterCardProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<RegisterCardProps>(`customers/cards/create`, payload);
      return response.data.card;
    } catch (error) {
      console.error('Erro registerCard:', error);
      throw error;
    }
  }

  async getCartOpen(params: GetCartOpenProps): Promise<any> {
    try {
      const response = await this.baseService.http.get<{ params: GetCartOpenProps }>(`cart/open-cart?store_id=${params.store_id}&order_type=${params.order_type} `);
      return response.data;
    } catch (error) {
      console.error('Erro getCartOpen:', error);
      throw error;
    }
  }

  async getCustomerOrders(params: GetCustomerOrdersProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get(`customers/${params.user_id}/orders`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async keycloakDecrypt(params: KeycloakDecryptProps): Promise<any> {
    try {
      const headers: Record<string, string> = {};
      if (params.guest_token) {
        headers['Guest-Token'] = params.guest_token;
      }

      const url = `${process.env.REACT_APP_URL_SSO_DECRYPT!}?company=${params.hash}&state=${params.state}&session_state=${params.session_state}&code=${params.code}&redirect=${window.location.pathname}`;
      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
  };

  async getCustomerOrdersToday(params: GetCustomerOrdersTodayProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get(`customers/${params.user_id}/today-orders`);
      return response.data;
    } catch (error) {
      console.error('Erro getCustomerOrdersToday:', error);
      throw error;
    }
  }

  async getCustomerAddresses(): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get(`customers/addresses`);
      return response.data;
    } catch (error) {
      console.error('Erro getCustomerAddresses:', error);
      throw error;
    }
  }

  async deleteAddress(address_id: number): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<any>(`customers/addresses/${address_id}/delete`, {});
      return response.data;
    } catch (error) {
      console.error('Erro deleteAddress:', error);
      throw error;
    }
  }

  async updatePassword(payload: UpdatePasswordProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<any>(`customers/password`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro updatePassword:', error);
      throw error;
    }
  }


  async confirmProfile(payload: any): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post('customers/confirm-profile', payload);
      return response.data;
    } catch (error) {
      console.error('Erro confirmProfile:', error);
      throw error;
    }
  }

  async acceptFidelityTerms(): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get('customers/accepted-terms');
      return response.data;
    } catch (error) {
      console.error('Erro acceptFidelityTerms:', error);
      throw error;
    }
  }



  async getFidelityExpireInfo(): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get('customers/fidelity/expire-info');
      return response.data;
    } catch (error) {
      console.error('Erro getFidelityExpireInfo:', error);
      throw error;
    }
  }

  async answerFidelityQuestions(payload: any[]): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post('fidelity-question/answer', payload);
      return response.data;
    } catch (error) {
      console.error('Erro answerFidelityQuestions:', error);
      throw error;
    }
  }

  async getMainInfo(): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get(`customers/profile/main-info`);
      return response.data;
    } catch (error) {
      console.error('Erro getMainInfo:', error);
      throw error;
    }
  }

  async getProfile(): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get(`customers/profile`);
      return response.data;
    } catch (error) {
      console.error('Erro getProfile:', error);
      throw error;
    }
  }

}
